import { IntersectionService } from './IntersectionService';
import { PositionService } from './PositionService';
import { BoundingBoxService } from './BoundingBoxService';
export class BinarySearchCameraOptimizer {
    static create(size, minDistance, maxDistance, precision = 0.001, maxIteration = 1000) {
        const positionService = new PositionService();
        const intersectionService = new IntersectionService(size, positionService, new BoundingBoxService(), {
            padding3D: { top: 0.0, left: 0.0, right: 0.0 },
        });
        return new BinarySearchCameraOptimizer(minDistance, maxDistance, intersectionService, positionService, precision, maxIteration);
    }
    constructor(minDistance, maxDistance, intersectionService, positionService, precision = 1, maxIteration = 10000) {
        this.minDistance = minDistance;
        this.maxDistance = maxDistance;
        this.intersectionService = intersectionService;
        this.positionService = positionService;
        this.precision = precision;
        this.maxIteration = maxIteration;
        this.min = this.minDistance;
        this.max = this.maxDistance;
    }
    optimizeCameraPosition(camera, state, root, screenBoxes) {
        this.intersectionService.init(screenBoxes, root);
        this.positionService.init(camera, state);
        this.min = this.minDistance;
        this.max = this.maxDistance;
        if (this.intersectionService.intersects(this.max)) {
            return { state: this.positionService.stateFromDistance(this.max), distance: this.max };
        }
        if (!this.intersectionService.intersects(this.min)) {
            return { state: this.positionService.stateFromDistance(this.min), distance: this.min };
        }
        let iterations = 0;
        let error = Infinity;
        let middle = this.max;
        while (iterations < this.maxIteration && error > this.precision) {
            middle = 0.5 * (this.max + this.min);
            if (this.intersectionService.intersects(middle)) {
                this.min = middle;
            }
            else {
                this.max = middle;
            }
            error = Math.abs(this.max - this.min);
            iterations++;
        }
        const distance = this.max;
        return { state: this.positionService.stateFromDistance(distance), distance };
    }
}
//# sourceMappingURL=BinarySearchCameraOptimizer.js.map